var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-carousel-card" }, [
    _c("div", { staticClass: "dashboard-carousel-card-wrapper" }, [
      _c("div", { staticClass: "dashboard-carousel-card-image" }, [
        _c(
          "picture",
          {
            directives: [
              {
                name: "lazyload",
                rawName: "v-lazyload",
                value: {
                  src: _vm.card.imgSrc,
                  set: [
                    { width: "480", height: "240", breakpoint: "xs" },
                    { width: "800", height: "360", breakpoint: "md" },
                  ],
                  fit: "crop",
                  align: "center",
                },
                expression:
                  "{\n          src: card.imgSrc,\n          set: [\n            { width: '480', height: '240', breakpoint: 'xs' },\n            { width: '800', height: '360', breakpoint: 'md' },\n          ],\n          fit: 'crop',\n          align: 'center',\n        }",
              },
            ],
            staticClass: "image-wrapper",
          },
          [
            _c("img", {
              staticClass: "image",
              attrs: {
                src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                alt: _vm.card.imgAlt,
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dashboard-carousel-card-content" }, [
        _c("span", { staticClass: "dashboard-carousel-card-title" }, [
          _vm._v(_vm._s(_vm.card.title)),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "dashboard-carousel-card-description" }, [
          _vm._v(_vm._s(_vm.card.description)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dashboard-carousel-card-ctas" }, [
          _c(
            "a",
            {
              staticClass: "dashboard-carousel-card-ctas-link",
              attrs: { href: _vm.ctaHref, target: _vm.card.ctaTarget },
            },
            [_vm._v("\n          " + _vm._s(_vm.card.ctaLabel) + "\n        ")]
          ),
          _vm._v(" "),
          _vm.showDismissBtn
            ? _c(
                "a",
                {
                  staticClass: "button dashboard-carousel-card-ctas-dismiss",
                  on: {
                    click: function ($event) {
                      return _vm.handleDismissClick()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.tc("auth.dismiss")))]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }